export default {

    state: {
      comarca: null,
      msgComarca: null
    },
  
    mutations: {
        setComarca(state, payload) {
          state.comarca = payload;
        },
        setMsgComarca(state, payload) {
          state.msgComarca = payload;
        }
    },
  
    getters: {
      getComarca(state) {
          return state.comarca;
      },
      getMsgComarca(state) {
        return state.msgComarca;
    }
    },

    actions: {
        setComarca({commit}, comarca){
          commit('setComarca', comarca);
        },
        setMsgComarca({commit}, msgComarca){
          commit('setMsgComarca', msgComarca);
        },
    },
    
  }